
/**
 * This function is used for the patient stub for 
 * order details 
 */

export const patientStubForOrders = () => (
    {
      "key":"1",
      "Created": "5/30/2020 6:37pm",
      "RequestId": "242567",
      "ProcedureName": "CT-BX S.T. SUPERFICIAL PELVIS/HIP RIGHT",
      "RequestingProvider": "Vehr, Geraldine M., MD",
      "CreationDepartment": "TCHMA MT AUBURN 520",
      "Status": "Active",
      "PatientPreferredLanguage": "English",
      "VisitDeptIDs": "1010101701",
      "VisitTypeIDs": "10510055",
      "SpecialityID": "40"
    }
  );
  
  